import React, { FC, useCallback, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import {
  addCategory,
  updateCategory,
  removeCategory,
  closeModals,
} from 'data/cacheHelpers/menu';

import ModalScreen from 'components/Modals/ModalScreen';
import AskBeforeDelete from 'components/Modals/AskBeforeDelete';
import {
  Container,
  ActionBar,
  Actions,
  ActionButton,
  Button,
  Input,
} from './styles';
import { Props } from './types';
import { validationSchema } from './constants';

const CategoryModal: FC<Props> = ({ brandId, previousData, isProcessing }) => {
  const [isConfirmRemoveOpen, setConfirmRemove] = useState(false);
  const isNew = previousData === undefined;

  const handleSubmit = useCallback(
    (values: any) => {
      if (previousData === undefined) {
        addCategory(brandId, values);
      } else {
        updateCategory(brandId, values);
      }
      closeModals(brandId);
    },
    [previousData, brandId],
  );

  const askConfirmRemove = useCallback(() => setConfirmRemove(true), []);
  const closeConfirmRemove = useCallback(() => setConfirmRemove(false), []);

  const handleRemove = useCallback(() => {
    if (previousData) {
      removeCategory(brandId, previousData);
      closeModals(brandId);
    }
  }, [brandId, previousData]);

  const closeModal = useCallback(() => closeModals(brandId), [brandId]);

  return (
    <ModalScreen
      open
      title={`${isNew ? 'Add' : 'Edit'} category`}
      handleClose={closeModal}
      showCloseButtonHeader={false}
    >
      <Formik
        initialValues={previousData || { name: '' }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        <Form noValidate>
          <Container>
            <Field
              name="name"
              as={Input}
              label="Category name"
              placeholder="Add name"
              disabled={isProcessing}
            />
          </Container>
          <ActionBar>
            <Actions>
              <ActionButton
                variant="delete"
                type="button"
                onClick={askConfirmRemove}
                disabled={isNew || isProcessing}
              />
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                onClick={closeModal}
                style={{ marginLeft: 'auto' }}
              >
                Cancel
              </Button>
              <Button color="secondary" type="submit" disabled={isProcessing}>
                Save
              </Button>
            </Actions>
          </ActionBar>
          {isConfirmRemoveOpen && !isNew && (
            <AskBeforeDelete
              message="Are you sure you want to delete this category?"
              handleRemove={handleRemove}
              handleClose={closeConfirmRemove}
            />
          )}
        </Form>
      </Formik>
    </ModalScreen>
  );
};

export default CategoryModal;

// TODO: TFR-29 add story to component
